module.exports = __webpack_public_path__ + "static/media/1.64f0ef8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/600590/1.jpg
// module id = 684
// module chunks = 0